(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-lp-clip]'));
  var bar = document.querySelector('[data-hhlp-sticky]');
  var hero = document.querySelector('.hhlp-hero');
  if (!vids.length && !(bar && hero)) return;

  function loadVid(v){
    if (!v.dataset.loaded) { v.preload = 'auto'; v.load(); v.dataset.loaded = '1'; }
    if (!reduce && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  }

  function sync(){
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i], r = v.getBoundingClientRect();
      if (r.top < vh * 1.25 && r.bottom > vh * -0.25) { loadVid(v); }
      else if (!v.paused) { v.pause(); }
    }
    if (bar && hero) {
      var want = !((window.pageYOffset || document.documentElement.scrollTop) > hero.offsetHeight * 0.75);
      if (bar.hidden !== want) { bar.hidden = want; }
    }
  }

  var queued = false;
  function onScroll(){
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function(){ queued = false; sync(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-stockists"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-hhwtb]');
  if (!root) return;
  var cards = Array.prototype.slice.call(root.querySelectorAll('.hhwtb-card'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.hhwtb-chip'));
  var search = root.querySelector('[data-hhwtb-search]');
  var countEl = root.querySelector('[data-hhwtb-count]');
  var emptyEl = root.querySelector('[data-hhwtb-empty]');
  var active = {};

  function apply() {
    var terms = (search.value || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
    var activeCats = Object.keys(active).filter(function (k) { return active[k]; });
    var shown = 0;
    cards.forEach(function (card) {
      var hay = card.getAttribute('data-search') || '';
      var cats = card.getAttribute('data-cats') || '';
      var textOk = terms.every(function (t) { return hay.indexOf(t) > -1; });
      var catOk = !activeCats.length || activeCats.some(function (c) { return cats.indexOf(c) > -1; });
      var ok = textOk && catOk;
      card.hidden = !ok;
      if (ok) shown++;
    });
    if (countEl) countEl.textContent = shown;
    if (emptyEl) emptyEl.hidden = shown !== 0;
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = (chip.getAttribute('data-cat') || '').toLowerCase();
      active[cat] = !active[cat];
      chip.classList.toggle('is-active', active[cat]);
      apply();
    });
  });

  if (search) {
    search.addEventListener('input', apply);
    search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }
  root.querySelectorAll('[data-hhwtb-find]').forEach(function (b) { b.addEventListener('click', apply); });
  root.querySelectorAll('[data-hhwtb-all]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (search) search.value = '';
      active = {};
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      apply();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-usp-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Attach the video source only when the section is about to be seen.
     Degrades safely: no IntersectionObserver (older Safari) just means it
     loads on window load instead, which is still off the critical path. */
  function attach(v) {
    if (!v || v.getAttribute('data-hh-uv-loaded')) return;
    var url = v.getAttribute('data-src');
    if (!url) return;
    v.setAttribute('data-hh-uv-loaded', '1');
    var s = document.createElement('source');
    s.src = url; s.type = 'video/mp4';
    v.appendChild(s);
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});   /* autoplay refused - poster stays */
  }
  Array.prototype.forEach.call(document.querySelectorAll('.hh-uv video[data-hh-uv-video]'), function (v) {
    if (!('IntersectionObserver' in window)) {
      if (document.readyState === 'complete') attach(v);
      else window.addEventListener('load', function () { attach(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { attach(e.target); io.disconnect(); } });
    }, { rootMargin: '300px 0px' });
    io.observe(v);
  });

  var btns = document.querySelectorAll('.hh-uv [data-hh-uv-sound]');
  Array.prototype.forEach.call(btns, function (btn) {
    var media = btn.closest('.hh-uv-media');
    var v = media && media.querySelector('video');
    if (!v) return;
    btn.addEventListener('click', function () {
      attach(v);
      v.muted = !v.muted;
      media.classList.toggle('is-loud', !v.muted);
      if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-videos"] && !Shopify.designMode) return;
  try {
    
(function(){
  var tiles = document.querySelectorAll('.hhv-media video');
  if (!tiles.length) return;
  /* pull the poster in only when the tile is near view, so the ~560KB of
     poster frames never touch the initial page load */
  function reveal(v){ if (v.dataset.poster && !v.getAttribute('poster')) { v.setAttribute('poster', v.dataset.poster); } }
  function play(v){ reveal(v); if (v.preload === 'none') { v.preload = 'auto'; v.load(); } var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(tiles, play);
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { play(e.target); }
      else if (!e.target.paused) { e.target.pause(); }
    });
  }, { rootMargin: '150px 0px', threshold: 0.2 });
  Array.prototype.forEach.call(tiles, function(v){ io.observe(v); });
})();

/* sound toggle - only ever one clip audible at a time */
(function(){
  var btns = document.querySelectorAll('.hhv [data-hhv-sound]');
  if (!btns.length) return;
  function tileOf(el){ while (el && el.className.indexOf('hhv-tile') < 0) { el = el.parentNode; } return el; }
  Array.prototype.forEach.call(btns, function(btn){
    var tile = tileOf(btn);
    var v = tile && tile.querySelector('video');
    if (!v) return;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (v.muted) {
        Array.prototype.forEach.call(document.querySelectorAll('.hhv-media video'), function(o){ if (o !== v) { o.muted = true; o.controls = false; } });
        Array.prototype.forEach.call(document.querySelectorAll('.hhv-tile'), function(t){ t.classList.remove('is-loud'); });
        v.muted = false;
        v.controls = true;
        tile.classList.add('is-loud');
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        var p = v.play();
        if (p && p.catch) { p.catch(function(){}); }
      } else {
        v.muted = true;
        v.controls = false;
        tile.classList.remove('is-loud');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
